
import StoreInfo from "./StoreInfo.vue"
export default {
  comments: {
    StoreInfo
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    storeInfo: {
      type: Object,
      default: () => {}
    },
    services: {
      type: Array,
      default: () => []
    },
    isNearestStore: {
      type: Boolean,
      default: false
    }
  }
}
